import { siteKey } from 'constants/config/recaptcha';

export default async action => {
  const { grecaptcha } = window || {};
  if (window === undefined || grecaptcha === undefined) return false;
  const token = await grecaptcha.execute(siteKey, {
    action,
  });
  return token;
};
